import ColorlessCommunicationsIcon from './Communications.svg'
import ColorlessDeckIcon from './Decks.svg'
import ColorlessDefenseIcon from './Defense.svg'
import ColorlessPowerIcon from './Power.svg'
import ColorlessSensorsIcon from './Scanning.svg'
import ColorlessThrustersIcon from './Thrusters.svg'
import ColorlessTractorBeamIcon from './TractorBeam.svg'
import ColorlessTransporterIcon from './Transporter.svg'
import StudentHealthIcon from './StudentHealthIcon.svg'

const DeathIcon =
	'https://resources-cdn.mission.io/simulations/general/death-icon.png'
const NotificationIcon =
	'https://resources-cdn.mission.io/simulations/general/notification-icon.png'
const ObjectiveIcon =
	'https://resources-cdn.mission.io/simulations/general/objective-icon.png'
const ShipHealthIcon =
	'https://resources-cdn.mission.io/simulations/general/ship-health-icon.png'
const TimerIcon =
	'https://resources-cdn.mission.io/simulations/general/timer-icon.png'
export {
	ColorlessCommunicationsIcon,
	ColorlessDeckIcon,
	ColorlessDefenseIcon,
	ColorlessPowerIcon,
	ColorlessSensorsIcon,
	ColorlessThrustersIcon,
	ColorlessTractorBeamIcon,
	ColorlessTransporterIcon,
	DeathIcon,
	NotificationIcon,
	ObjectiveIcon,
	ShipHealthIcon,
	TimerIcon,
	StudentHealthIcon,
}
